import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-data-requirements-dialog',
  templateUrl: './data-requirements-dialog.component.html',
  styleUrls: ['./data-requirements-dialog.component.scss']
})
export class DataRequirementsDialogComponent {
  @Input() isOpen = false;
  @Output() closed = new EventEmitter<void>();

  close(): void {
    this.closed.emit();
  }
}
